import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import globel from './global_variable'
import axios from './http'

import '@/assets/iconfont/iconfont.css'
import '@/assets/css/share.min.css'

import Share from 'vue-social-share'
Vue.use(Share)

import MetaInfo from 'vue-meta-info' 
Vue.use(MetaInfo)

Vue.prototype.$globel = globel

Vue.config.productionTip = false
Vue.prototype.$axios = axios
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
